import { Navigate, Outlet, useLocation } from "react-router";
import { getIsAuthenticated } from "@/src/common/redux/session-slice";
import { useAppSelector } from "@/src/common/redux/store";

export const AuthGuard: React.FC = () => {
	const isAuthenticated = useAppSelector(getIsAuthenticated);
	const location = useLocation();

	if (!isAuthenticated) {
		return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
	}
	return <Outlet />;
};
